import { GetTypeLabelList } from '../../services/apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../../services/apiUtils';

export interface TypeLabelParam {
  rmaNo: string;
  categoryId: string;
}

const endPoint = 'inspection/type/label-list';
const endPointQc = 'qc/type/label-list';

export const fetchTypeLabels = async (
  params: TypeLabelParam,
): Promise<GetTypeLabelList> => {
  const queryParams = new URLSearchParams();
  queryParams.append('rmaNo', params.rmaNo);
  queryParams.append('categoryId', params.categoryId);
  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const fetchQcTypeLabels = async (
  params: TypeLabelParam,
): Promise<GetTypeLabelList> => {
  const queryParams = new URLSearchParams();
  queryParams.append('rmaNo', params.rmaNo);
  queryParams.append('categoryId', params.categoryId);
  const apiUrl = getApiUrl(endPointQc);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );

  return response.data;
};
